import {useDispatch} from 'react-redux'
import { saveToken } from '../actions';


export const AutoRefreshToken = (data)=>{
    const dispatch = useDispatch();
    dispatch(saveToken(data))
}
